import React, { useEffect, useMemo } from "react";
import { NavToolSearchProps } from "./types/NavToolSearch.types";
import "./NavToolSearch.scss";
import { Link, Text } from "@sitecore-jss/sitecore-jss-react";
import { trackWithGoogleTagManager } from "../../../../utils/analytics";

const NavToolSearch = ({
  search,
  searchSet,
  searchIsOpenSet,
  searchIsOpen,
  label,
  link,
}: NavToolSearchProps) => {
  const searchClass = useMemo(() => {
    return searchIsOpen ? "Nav__Search Nav__Search--Open" : "Nav__Search";
  }, [searchIsOpen]);

  const searchFieldClass = useMemo(() => {
    return search?.length > 2
      ? "Nav__SearchField Nav__SearchField--active"
      : "Nav__SearchField";
  }, [search]);

  function getSearchUrl(baseUrl: string, query: string) {
    if (typeof window !== "undefined") {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set("q", query);
      return url.toString();
    } else {
      return baseUrl;
    }
  }

  function track() {
    trackWithGoogleTagManager({
      event: "event_search_website",
      eventAction: "submit_search",
      eventCategory: "search_website",
      eventLabel: search,
    });
  }
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (searchIsOpen && search?.length > 2) {
        window.addEventListener("keypress", (event) => {
          if (searchIsOpen && event.key === "Enter") {
            location.replace(getSearchUrl(link.value.href, search));
          }
        });
      }
    }
  }, [window, searchIsOpen, search]);
  return (
    <div className={searchClass}>
      <span
        className="icon icon-lens Nav__SearchIcon ga4-click-ui-navbar"
        onClick={searchIsOpenSet}
      />
      <div className={searchFieldClass}>
        <input value={search} onChange={(v) => searchSet(v.target.value)} />
        <Text tag="label" field={label}></Text>
        <Link
          className="Nav__SearchArrow arrow-right"
          field={{
            ...link,
            value: {
              ...link.value,
              href: getSearchUrl(link.value.href, search),
            },
          }}
          onClick={track}
        >
          <span></span>
        </Link>
      </div>
    </div>
  );
};

export default NavToolSearch;
